import { render, staticRenderFns } from "./Report_promotion_mobile_type.vue?vue&type=template&id=1f274b72&scoped=true&"
import script from "./Report_promotion_mobile_type.vue?vue&type=script&lang=js&"
export * from "./Report_promotion_mobile_type.vue?vue&type=script&lang=js&"
import style0 from "./Report_promotion_mobile_type.vue?vue&type=style&index=0&id=1f274b72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f274b72",
  null
  
)

export default component.exports